<template>
  <b-modal
    :id="`${attrs.name}-modal-value-help`"
    ref="value-help-modal-ref"
    centered
    hide-header-close
    size="lg"
    cancel-variant="outline-primary"
    :title="attrs.modalTitle || $t('global.form.select') + ` ${context.label}`"
    :ok-title="context.okTitle || $t('global.action.apply')"
    :cancel-title="context.cancelTitle || $t('global.action.cancel')"
    :ok-disabled="isEditing"
    @hidden="handleHide"
    @ok="handleApply"
  >
    <div class="mc-value-help">
      <LocalTable
        ref="table-modal-ref"
        :isBusy.sync="isBusy"
        :totalCount.sync="totalCount"
        :isEditing.sync="isEditing"
        :selectedModel="context.model"
        :fullObject="fullObject"
        :attrs="attrs"
        :multiple="multiple"
        :listGetter="attrs.listGetter"
      >
        <template v-for="val in slotFields" #[val.name]="{ item }">
          <slot :name="val.name" :item="item"></slot>
        </template>
      </LocalTable>
      <TableFooter :totalCount="totalCount" />
    </div>
  </b-modal>
</template>

<script>
import LocalTable from './ModalBody/TableValueHelp'
import TableFooter from './ModalBody/Footer'

export default {
  components: {
    LocalTable,
    TableFooter,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },

    attrs: {
      type: Object,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    fullObject: {},
  },
  emits: ['update:fullObject'],
  data() {
    return {
      isBusy: false,
      isEditing: false,
      totalCount: null,
    }
  },
  computed: {
    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },
  },
  methods: {
    handleAdd() {
      // show the custom modal
      if (this.attrs['has:createModal']) {
        this.$bvModal.show(`${this.attrs.name}-create-data-modal`)
        return
      }

      this.isEditing = true
      this.$refs['table-modal-ref'].HandleAdd()
    },
    handleHide() {
      this.totalCount = null
      this.isEditing = false

      this.$emit('update:context', { ...this.context, blurHandler: this.context.blurHandler() })
    },
    handleApply() {
      const { selectedValues, selectedObject } = this.$refs['table-modal-ref'].HandleApply()
      // Filter out the selected values that are false (unselected)

      let fullObject
      if (this.multiple) {
        fullObject = selectedValues.reduce((acc, curr) => {
          if (selectedObject[curr]) acc.push(selectedObject[curr])
          return acc
        }, [])
      } else {
        fullObject = selectedObject[selectedValues[0]] || {}
      }

      this.$emit('update:fullObject', fullObject)
      // eslint-disable-next-line vue/no-mutating-props
      this.context.model = this.multiple ? selectedValues : selectedValues[0]
      this.context.blurHandler()
    },
  },
}
</script>
